export default __webpack_public_path__ + "static/19-0c683f07a2694c74a6b478acdab93978.webp";